<template>
  <div>
    <p class="titleModal">
      {{ $t(`technicalFile.cooling.step0.title`) }}
    </p>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.name"
          :label="$t('technicalFile.cooling.step0.name')"
          :rules="{ required: true, min: 1, max: 200 }"
          class="text-field-transparent"
          :readonly="readonly"
          outlined
          flat
          data-cy="networkIdentification-name"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.regulatoryIdentification"
          :label="$t('technicalFile.cooling.step0.regulatory')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="networkIdentification-RegulatoryIdentification"

          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="noYPadding"
      >
        <div>
          <VDatePicker
            v-model="data.auditDate"
            value=""
            outlined
            :disabled="readonly"
            flat
            data-cy="network-identification-date"
            :label="$t('technicalFile.cooling.step0.auditDate')"
            @input="updateData"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';

export default {
    name: 'NetworkIdentification',
    components: {
        VTextField,
        VDatePicker,
    },
    props: {
        networkIdentification: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    watch: {
        networkIdentification: {
            handler() {
                this.data = { ...this.data, ...this.networkIdentification };
                this.data.auditDate = this.data.auditDate && this.data.auditDate.length
                    ? this.data.auditDate : '';
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { networkIdentification: this.data });
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.noYPadding {
  padding-bottom: 0;
  padding-top: 0;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
